import type { Address, DefaultQueryError } from '@ahm/api-wrappers-core';
import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import {
  type AutocompleteParams,
  getAutocompleteFn,
} from './ahafood/get-autocomplete-fn';
import { apiRoutes } from './api-routes';

export const useAutocomplete = (
  params: AutocompleteParams,
  opts?: Partial<UseQueryOptions<Address[], DefaultQueryError>>
) =>
  useQuery<Address[], DefaultQueryError>({
    // Key phải chứa TOÀN BỘ params (kể cả lat/lng bias) — chỉ lấy `input` sẽ
    // khiến hai vị trí khác nhau dùng chung cache.
    queryKey: [apiRoutes.place.autocomplete, params],
    queryFn: () => getAutocompleteFn(params),
    ...opts,
  });
